import * as React from 'react'
import { Block } from '../Layout/Block'
import { Text } from '$views/components/Text'
import { Stars } from '$views/components/Stars'
import { RoundedImage } from '$views/components/RoundedImage'

interface Props {
  image: any
  body: string
  name: string
  subtitle: string
}

export const CitationCard: React.SFC<Props> = ({ image, body, name, subtitle }) => {
  return (
    <>
      <Block flex>
        <Block>
          <RoundedImage urlImage={image} size="normal" textImage={name} />
        </Block>
        <Block flex alignItems="center" marginLeft="mini">
          <Block>
            <Text subheader>{name}</Text>
            <Text menu>{subtitle}</Text>
            <Stars showOnlyStars rating={5} />
          </Block>
        </Block>
      </Block>
      <Text marginTop="tiny">{body}</Text>
    </>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/CitationCard/CitationCard.tsx